import React, {FunctionComponent as FC, useContext} from "react";
import Header from "./components/header/index";
import Sponsors from "./components/sponsors/index";
import Footer from "./components/footer/index";
import {Helmet} from "react-helmet";
import {AssetContext} from "./provider/asset";

type LayoutProps = {};

const Layout: FC<LayoutProps> = ({children}) => {
  const {isSwissPost} = useContext(AssetContext);

  const pliIcons = [
    {rel: "apple-touch-icon", sizes: "57x57", name: "/favicons/pli/apple-icon-57x57.png"},
    {rel: "apple-touch-icon", sizes: "60x60", name: "/favicons/pli/apple-icon-60x60.png"},
    {rel: "apple-touch-icon", sizes: "72x72", name: "/favicons/pli/apple-icon-72x72.png"},
    {rel: "apple-touch-icon", sizes: "76x76", name: "/favicons/pli/apple-icon-76x76.png"},
    {rel: "apple-touch-icon", sizes: "114x114", name: "/favicons/pli/apple-icon-114x114.png"},
    {rel: "apple-touch-icon", sizes: "120x120", name: "/favicons/pli/apple-icon-120x120.png"},
    {rel: "apple-touch-icon", sizes: "144x144", name: "/favicons/pli/apple-icon-144x144.png"},
    {rel: "apple-touch-icon", sizes: "152x152", name: "/favicons/pli/apple-icon-152x152.png"},
    {rel: "apple-touch-icon", sizes: "180x180", name: "/favicons/pli/apple-icon-180x180.png"},
    {rel: "icon", type: "image/png", sizes: "192x192", name: "/favicons/pli/android-icon-192x192.png"},
    {rel: "icon", type: "image/png", sizes: "32x32", name: "/favicons/pli/favicon-32x32.png"},
    {rel: "icon", type: "image/png", sizes: "96x96", name: "/favicons/pli/favicon-96x96.png"},
    {rel: "icon", type: "image/png", sizes: "16x16", name: "/favicons/pli/favicon-16x16.png"}
  ];

  const SwissIcons = [
    {
      rel: "apple-touch-icon", sizes: "180x180", // standard iOS touch icon size
      name: "/favicons/swiss/apple-touch-icon.png"
    },
    {rel: "icon", type: "image/png", sizes: "192x192", name: "/favicons/swiss/android-chrome-192x192.png"},
    {rel: "icon", type: "image/png", sizes: "512x512", name: "/favicons/swiss/android-chrome-512x512.png"},
    {rel: "icon", type: "image/svg+xml", name: "/favicons/swiss/favicon.svg"},
    {rel: "shortcut icon", type: "image/x-icon", name: "/favicons/swiss/favicon.ico"}
  ];

  // Choose the correct icons based on the current theme.
  const icons = isSwissPost ? SwissIcons : pliIcons;

  return (
    <>
      <Helmet>
        {icons.map((icon) => (
          <link
            key={icon.sizes || icon.name}
            rel={icon.rel}
            type={icon.type || "image/png"}
            sizes={icon.sizes}
            href={icon.name}
          />
        ))}
        <meta name="msapplication-TileColor" content="#234323" />
        <meta
          name="msapplication-TileImage"
          content="/ms-icon-144x144.png"
        />
        {/*<meta name="theme-color" content={theme.primary} />*/}
      </Helmet>
      <Header />
      <main>{children}</main>
      <Sponsors />
      <Footer />
    </>
  );
};

export default Layout;
